import script from "./SyncOpItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncOpItem.vue?vue&type=script&setup=true&lang=ts"

import "./SyncOpItem.vue?vue&type=style&index=0&id=788dfad1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-788dfad1"]])

export default __exports__